import { useState } from "react";
import React from "react";
import image from "assets/images/Bakery.png";
import image2 from "assets/images/Protein.png";
import image3 from "assets/images/FruitsandVegetables.png";
import image4 from "assets/images/sweet.svg";
import flower from "assets/images/Flowers.png";
import pharmacy from "assets/images/Medicine.png";
import coffee from "assets/images/New folder/coffee.png";
import food2 from "assets/images/khanegi.png";
import supermarket from "assets/images/supermarket.png";
import juice from "assets/images/coffe.png";
import pet from "assets/images/PetShop.png";
import Loader from "utils/Loader";
import styles from "./shop.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import mainImage from "assets/images/Main Image.png";

import { Navigation, Pagination } from "swiper";
import Formatter from "hoc/Formatter";
import { CategoryItem } from "../fastOrdering/Category.jsx";

const Shop = () => {
  const [cats, setCats] = useState([
    { src: juice, title: "کافه و آبمیوه" },
    { src: image3, title: "میوه و سبزی" },
    { src: image2, title: "محصولات پروتئینی" },
    { src: pet, title: "پت شاپ" },
    { src: image, title: "نان و شیرینی" },
    { src: flower, title: "گل" },
    { src: pharmacy, title: "داروخانه" },
    { src: supermarket, title: "سوپرمارکت" },
    { src: food2, title: "محصولات غذای خانگی" },
  ]);
  return (
    <div className="sabadi-slider">
      <div
        style={{
          width: "100%",
          backgroundColor: "#f1eae5",
          position: "relative",
          marginTop: "200px",
          paddingTop: "100px",
        }}
      >
        <div
          className="header-shop d-flex justify-content-around flex-row-reverse"
          style={{}}
        >
          <div
            className="header-image"
            style={{ paddingBottom: "100px", width: "50%" }}
          >
            <img src={mainImage} />
          </div>
          <div className="w-50">
            <h1 className="title1" style={{ paddingRight: "100px" }}>
              سبدی
            </h1>
            <h1 className="title2 " style={{ paddingRight: "100px" }}>
              همراه یک خرید کامل!
            </h1>
          </div>
        </div>

        <div className=" mt-1 category" style={{ padding: "100px 6% 20px" }}>
          <Formatter header="دسته بندی محصولات" color="#6134ff">
            <Swiper
              navigation={true}
              modules={[Navigation]}
              breakpoints={{
                300: {
                  slidesPerView: 1,
                  spaceBetween: 7,
                },
                360: {
                  slidesPerView: 2,
                  spaceBetween: 7,
                },
                550: {
                  slidesPerView: 3,
                  spaceBetween: 7,
                },

                700: {
                  slidesPerView: 4,
                  spaceBetween: 7,
                },

                1024: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                1200: {
                  slidesPerView: 7,
                  spaceBetween: 10,
                },
                1500: {
                  slidesPerView: 8,
                  spaceBetween: 10,
                },

                1700: {
                  slidesPerView: 9,
                  spaceBetween: 2,
                },
              }}
            >
              {cats.map((value) => {
                return (
                  <div style={{}}>
                    <SwiperSlide>
                      <CategoryItem
                        img={value.src}
                        title={value.title}
                        backgroundColor="white"
                      ></CategoryItem>
                    </SwiperSlide>
                  </div>
                );
              })}
            </Swiper>
          </Formatter>
        </div>
      </div>
    </div>
  );
};

export default Shop;
